module.exports = __webpack_public_path__ + "static/images/logo.93dd7e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo.png
// module id = Z2Ou
// module chunks = 1